
import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { T_Code } from "../../common/model/codeModel";
import { T_Trouble } from "../../common/model/troubleModel";
import outlined from "../../assets/theme/components/button/outlined";
import { T_user } from "../../common/model/user";
import { createImportSpecifier } from "typescript";


export default function UserInsert(){


    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_user>({role:"ADMIN"});
    const {alert,setAlert} = useAlert();
    const [typeList,setTypeList] = useState<T_Code[]>();
    const [gubunList,setGubunList] = useState<T_Code[]>();
    const [idCheck,setIdCheck] = useState(false);
   const [isMatch, setIsMatch] = useState(true);
    const handleChange = (event: SelectChangeEvent) => {
      setCstatus(event.target.value);
      };
      const [selectedFiles, setSelectedFiles] = useState<File[]>([])

      const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>,
      ) => {
        if (!event.target.files) return
        setSelectedFiles(Array.from(event.target.files))
      }    

      const handleRemoveFile = (index: number) => {
        setSelectedFiles(prev =>
          prev.filter((_, i) => i !== index)
        )
      }

      const idCheckFunction = async()=>{
        console.log("userId:",data.userId)
        if(data.userId === "" || data.userId === undefined){
            setAlert({...alert,visible:true,msg:"아이디를 입력하여 주세요"});
            setIdCheck(false);
            return false;
        }else{
        const result = await apis.user.userList({userId:data.userId})        
        console.log(result);
        if(result.code=="1"){
            if(result.data.list.length>0){
              setAlert({...alert,visible:true,msg:"이미 존재하는 아이디 입니다."})
              setIdCheck(false);
              return false;
            }else{
              setIdCheck(true);
              return true;
            }
        }else{

        }

        }
      }

   
      const saveData = async()=>{

        if(data.userId == "" || data.userId === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"아이디 입력하여 주십시요"})   
            return;
        }

        console.log("idcheck:",idCheck)
        if(!idCheck){
            setAlert({...alert,visible:true,msg:"ID 중복 체커를 해주십시요"})
            return;
        } 

       if(!isMatch){
            setAlert({...alert,visible:true,msg:"비밀번호를 확인 해주세요"})
            return;
        } 


        if(data.userNm == "" || data.userNm === undefined){
            setAlert({...alert,visible:true,title:"확인",msg:"사용자명을 입력해 주세요"})   
            return;
        }

        setAlert({...alert,title:"확인",msg:"정말로 등록 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.user.userInsert(data)   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록이 완료되었습니다."})
                        nav("/user")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }
useEffect(() => {
  if (data.userPw === '' && data.userPw1 === '') {
    setIsMatch(true);
  } else {
    setIsMatch(data.userPw === data.userPw1);
  }
}, [data.userPw, data.userPw1]);

    return(
    <>
    <Card >
        <CardHeader title="관리자 등록" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          아이디
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                                <Box sx={{display:'flex',flexDirection:'row'}}><TextField sx={{mb:2,mr:2}}  size="small" fullWidth value={data.userId || ''} onChange={(event)=>{setData({...data,userId:event.target.value}); setIdCheck(false)}} />
                                <Button sx={{width:100,mb:2,mr:2}} variant="contained"  size="small"  color={idCheck?"warning":"primary"} onClick={idCheckFunction} >중복확인</Button>
                          </Box>
                            </TableCell>      
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          패스워드
                        </TableCell>      

                        <TableCell sx={{textAlign:'left'}}>
                          <Box sx={{display:'flex',flexDirection:'row',mb:2}}><TextField type="password"   size="small" fullWidth value={data.userPw || ''} onChange={(event)=>{setData({...data,userPw:event.target.value})}} 

                            />
                            <Typography
                                  sx={{
                                    ml: 1,
                                    color: 'error.main',
                                    whiteSpace: 'nowrap',
                                    // 에러 없을 때는 숨기고, 있을 때만 보이기
                                    visibility: isMatch ? 'hidden' : 'visible',
                                    // 메시지가 길어도 줄바꿈 안 되도록
                                  }}
                                >
                                  패스워드가 일치하지 않습니다
                                </Typography>
                          </Box>
                        <Box sx={{display:'flex',flexDirection:'row'}}><TextField size="small" type="password" fullWidth value={data.userPw1 || ''} onChange={(event)=>{setData({...data,userPw1:event.target.value});}} />
                                      <Typography
                                  sx={{
                                    ml: 1,
                                    color: 'error.main',
                                    whiteSpace: 'nowrap',
                                    // 에러 없을 때는 숨기고, 있을 때만 보이기
                                    visibility: 'hidden' ,
                                    // 메시지가 길어도 줄바꿈 안 되도록
                                  }}
                                >
                                  패스워드가 일치하지 않습니다
                                </Typography>
                          </Box>
                
                        </TableCell>                         

          </TableRow>        
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          사용자명
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                        <TextField   size="small" fullWidth value={data.userNm || ''} onChange={(event)=>{setData({...data,userNm:event.target.value})}} 
                           inputProps={{ maxLength: 20 }} // 여기에 최대 길이 지정
                            sx={{ width: '40ch' }}
                          />
                        </TableCell>      

        </TableRow>          

        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained"  onClick={()=>{
          saveData();
          }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
         }}>취소</Button>

        </CCardFooter>
    </Card>

    </>)
}